export default {
  BusinessStockMovementLang: {
    PO_INBOUND: 'PO 入库',
    ORDER_OUTBOUND: '订单出库',
    CUSTOMER_RETURNS: '客户退货',
    STOCK_ADJUSTMENTS: '库存调整',
    USER : '用户 ID',
    DATE : '日期',
    SKU : 'SKU 信息',
    TYPE : '变动类型',
    QTY : '数量变化',
    REFERENCE  : '单据号',
    type1 : 'PO 入库',
    type2 : '订单出库',
    type3 : '退货入库',
    type4 : '库存调整',
  }
};
  